
const isDev = process.env.NODE_ENV === 'development'
const baseurl = isDev?'/_api' :''
const api = {
    checkUserAttribute: `${baseurl}/_web/_apps/ids/api/shutcm/checkUserAttribute.rst`,
    submitdata:`${baseurl}/_web/_apps/ids/api/shutcm/submitValidatePasswordRecoveryApply.rst`,
    getCodeFromUcpImpl:`${baseurl}/_web/_apps/ids/api/shutcm/getCodeFromUcpImpl.rst`,
    resetNewPasswordRecoveryApply:`${baseurl}/_web/_apps/ids/api/shutcm/resetNewPasswordRecoveryApply.rst`,
    getValidate:`${baseurl}/_web/_apps/ids/api/shutcm/isHasPhone.rst`,
    passwordLevel:`${baseurl}/_web/_apps/ids/api/shutcm/personal/passwordLevel.rst?domainId=1`,
}
// 查看密码等级
export function passwordLevel(parameters = {}) {
    return {
        url: api.passwordLevel,
        method: 'POST',
        data: parameters
    }
}

export function checkUserAttribute(parameters = {}) {
    return {
        url: api.checkUserAttribute,
        method: 'get',
        params: parameters
    }
}

export function submitdata(parameters = {}) {
    return {
        url: api.submitdata,
        method: 'post',
        data: parameters,
        params:{domainId:1}
    }
}

export function getCodeFromUcpImpl(parameters = {}) {
    return {
        url: api.getCodeFromUcpImpl,
        method: 'post',
        // data: parameters,
        params:{domainId:1}
    }
}

export function resetNewPasswordRecoveryApply(parameters = {}) {
    return {
        url: api.resetNewPasswordRecoveryApply,
        method: 'post',
        data: parameters?.data,
        params:parameters?.params
    }
}


export function getValidate(parameters = {}) {
    return {
        // url: api.getValidate+'?'+loginName+'=',
        url:`${api.getValidate}?loginName=${parameters?.loginName}`,
        method: 'GET',
        // data: parameters?.data,
        // params:parameters?.params
    }
}